import { render, staticRenderFns } from "./IotModelEventReportList.vue?vue&type=template&id=181f5bd6&scoped=true&"
import script from "./IotModelEventReportList.vue?vue&type=script&lang=js&"
export * from "./IotModelEventReportList.vue?vue&type=script&lang=js&"
import style0 from "./IotModelEventReportList.vue?vue&type=style&index=0&id=181f5bd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "181f5bd6",
  null
  
)

export default component.exports